function isPageValid(page, perPage, total) {
  if (page < 0) return false;
  if (!total) return true;
  var maxPage = Math.ceil(total / perPage) - 1; // 0 indexed

  return page <= maxPage;
}

export default isPageValid;
//# sourceMappingURL=isPageValid.esm.js.map
